import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import FAQ from '../views/faq.vue'
import ContactUs from '../views/ContactUs.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import Shop from '../views/Shop.vue'
import Prices from '../views/Prices.vue'
import ProductDetail from '../views/ProductDetail.vue'
import Cart from '../views/Cart.vue'
import PaymentSuccess from '../views/PaymentSuccess.vue'
import NotFound from '../views/PageNotFound.vue'

const routes = [
  /*{
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { title: 'Wingio - Safe Phone & Tablet for Kids' }
  },*/
  {
    path: '/',
    name: 'home',
    component: Shop,
    meta: { title: 'Wingio - Shop' }
  },
  {
    path: '/faq',
    name: 'Faq',
    component: FAQ,
    meta: { title: 'Wingio - FAQ' }
  },
  {
    path: '/contact-us',
    name: 'Contact Us',
    component: ContactUs,
    meta: { title: 'Wingio - Contact Us' }
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    component: PrivacyPolicy,
    meta: { title: 'Wingio - Privacy Policy' }
  },
  /*{
    path: '/prices',
    name: 'Prices',
    component: Prices,
    meta: { title: 'Wingio - Prices' }
  },*/
  {
    path: '/shop',
    name: 'Shop',
    component: Shop,
    meta: { title: 'Wingio - Shop' }
  },
  {
    path: '/phone',
    name: 'Phone',
    component: ProductDetail,
    meta: { title: 'Wingio - Product Detail' }
  },
  {
    path: '/cart',
    name: 'Cart',
    component: Cart,
    meta: { title: 'Wingio - Cart' }
  },
  {
    path: '/success',
    name: 'Payment Success',
    component: PaymentSuccess,
    meta: { title: 'Wingio - Payment Success' }
  },
  {
    // path: "*",
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: NotFound,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 }
  },
})
router.afterEach((to, from) => {
  document.title = to.meta.title;
});
export default router
